angular.module 'app'
.controller 'NewsAnalysisLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
